// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-dynamic-form-payload-request-schema',
  type: 'object',
  required: ['appSystemKey', 'formDefinitionId'],
  properties: {
    appSystemKey: {
      type: 'string',
    },
    formDefinitionId: {
      type: 'string',
    },
    contactId: {
      type: 'string',
    },
  },
} as IJSONSchema;

export default schema;
